import React from "react";
import AdmLetter from "./AdmLetter";
import AdmLetterPg2 from "./AdmLetterPg2";
import AdmissionLetterGenericPdfDownloader from "./../../../admin/routes/setup/timetable/admissionLetterdownloadPDF";

function FullAdmissionLetter({ applicant }) {
  return (
    <div>
      {/* Wrapper div with unique ID */}
      <div id="admission-letter">
        <AdmLetter applicant={applicant} />
        {/* <AdmLetterPg2 applicant={applicant} /> */}
      </div>

      {/* PDF Downloader Button */}
      <AdmissionLetterGenericPdfDownloader
        rootElementId="admission-letter"
        downloadFileName="FullAdmissionLetter"
      />
    </div>
  );
}

export default FullAdmissionLetter;
